export default {
    decreaseButtonTitle: String, 
    dragHandleTitle: String, 
    increaseButtonTitle: String, 
    largeStep: Number, 
    max: Number, 
    min: Number, 
    orientation: String, 
    showButtons: Boolean, 
    smallStep: Number, 
    tickPlacement: String, 
    tooltip: Object, 
    value: String | Number,

    // Events
    change: Function, 
    slide: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoSlider/SliderProps.js